import Swiper from 'swiper/bundle';
import Cookies from 'js-cookie';

window.customElements.define('quantity-selector', class QuantitySelector extends HTMLElement {
  constructor() {
    super()
    this.updateDiscountPrices()

    this.input = this.querySelector('input[type="number"]')
    this.minusButton = this.querySelector('button[name="minus"]')
    this.minValue = parseInt(this.input.min)
    this.changeEvent = new Event('change', { bubbles: true })

    this.input.addEventListener('change', this.onValueChange.bind(this))
    this.input.addEventListener('keyup', this.onValueChange.bind(this))
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    )
  }

  onValueChange(event) {
    if (this.input.value > this.minValue) {
      this.minusButton.removeAttribute('disabled')
    } else {
      this.minusButton.setAttribute('disabled', 'disabled')
    }
  }

  onButtonClick(event) {
    event.preventDefault()
    const previousValue = this.input.value
    let currentButton = event.target.closest('.quantity-selector__button');

    currentButton.name === 'plus' ? this.input.stepUp() : this.input.stepDown()

    // Continue dispatch if there was an actual change
    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent)
      this.updateDiscountPrices()
    }
  }

  updateDiscountPrices() {
    let allocatedAmountSummaryLine = 0

    document.querySelectorAll('.cart-item-item').forEach(function(el) {
      let allocatedAmount = 0
      const quantity = parseFloat(el.querySelector('.input-quantity')?.value)
      const priceText = el.querySelector('.item-original-price')?.textContent ?? ''
      if (priceText === '' || isNaN(quantity)) {
        return
      }
      const price = parseFloat(priceText.replace(/[^0-9.-]+/g, ''))

      allocatedAmount = quantity * price

      const allocatedEl = el.querySelector('.total-original-allocated-amount')
      if (allocatedEl) allocatedEl.textContent = '$' + allocatedAmount.toFixed(2)

      allocatedAmountSummaryLine = allocatedAmount
    })
    const totalEl = document.querySelector('.total-allocated-amount')
    if (totalEl) totalEl.textContent = '$' + allocatedAmountSummaryLine.toFixed(2)
  }
})

window.customElements.define('variant-picker', class VariantPicker extends HTMLElement {
  constructor() {
    super()
    this.addEventListener('change', this.onVariantChange)
    this.addEventListener('click', this.onSwatchClick);
    document.addEventListener("DOMContentLoaded", () => {
      const firstSwatch = document.querySelector(".swatch")
      if (firstSwatch) {
          firstSwatch.click()
      }

      const variantPicker = document.getElementById("product__main__variant-picker");
      if (variantPicker) {
        const selectElement = variantPicker.querySelector("select");
        if (selectElement) {
          this.updateOptions();  // Ensure options are set
          this.updateCurrentVariant(); // Set currentVariant on load
          if (this.currentVariant) {
              this.updateURL();
              this.updateVariantInput();
              this.renderProductInfo();
          } else {
              this.setUnavailable();
          }
        }
      }
    });
  }

  connectedCallback() {
    this.onVariantChange()
  }

  onVariantChange(evt) {
    // Product properties changes do not necessitate a full state update
    if (evt && evt.target.name.startsWith('properties[')) return
    if (evt && evt.target.classList.contains('swatch')) return

    this.updateOptions()
    this.updateCurrentVariant()
    this.toggleAddButton(true, true)
    this.removeErrorMessage()

    if (!this.currentVariant) {
      this.toggleAddButton()
      this.setUnavailable()
    } else {
      this.updateURL()
      this.updateVariantInput()
      this.renderProductInfo()
    }

    this.dispatchEvent(new Event('variantchange'))
  }

  onSwatchClick(evt) {
    if (evt.target.classList.contains('swatch')) {
      const targetSwatchValue = evt.target.getAttribute('data-select');

      // Find which option index this swatch controls and update only that index
      const fieldset = evt.target.closest('fieldset')
      const allPickers = [...this.querySelectorAll('fieldset, select')]
      const optionIndex = fieldset ? Math.max(0, allPickers.indexOf(fieldset)) : 0
      const newOptions = this.options ? [...this.options] : []
      newOptions[optionIndex] = targetSwatchValue
      this.options = newOptions
      this.updateCurrentVariant()
      this.highlightCurrentSwatch();
      this.toggleAddButton(true, true)
      this.removeErrorMessage()

      if (!this.currentVariant) {
        this.toggleAddButton()
        this.setUnavailable()
      } else {
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
      }

      this.dispatchEvent(new Event('variantchange'))
    }
  }

  highlightCurrentSwatch() {
    const swatches = this.querySelectorAll('.swatch');
    swatches.forEach((swatch) => {
      const value = swatch.dataset.value || swatch.textContent.trim();
      if (this.currentVariant.options.includes(value)) {
        swatch.classList.add('active'); // Add an `active` class
      } else {
        swatch.classList.remove('active');
      }
    });
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('fieldset, select'), (variantPicker) => {
      return variantPicker.tagName === 'FIELDSET'
        ? Array.from(variantPicker.querySelectorAll('input')).find((radio) => radio.checked).value
        : variantPicker.value
    })
  }

  updateCurrentVariant() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return variant.options.every((option, index) => {
        return this.options[index] === option
      })
    })
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;

    const currentUrl = new URL(window.location.href);
    const newUrl = new URL(this.dataset.url, window.location.origin);

    // merge all existing query parameters, including the UTM parameters
    currentUrl.searchParams.forEach((value, key) => {
      newUrl.searchParams.set(key, value);
    });

    newUrl.searchParams.set('variant', this.currentVariant.id);

    // Update the browser URL without reloading the page
    window.history.replaceState({}, '', newUrl.toString());
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`)
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]')
      input.value = this.currentVariant.id
      input.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }

  removeErrorMessage() {
    const section = this.closest('section')
    if (!section) return

    const productForm = section.querySelector('product-form')
    if (productForm) {
      const successNotification = productForm.querySelector('.product-form__cart-notification')
      successNotification.classList.remove('product-form__cart-notification--show')
    }
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `Price-${this.dataset.section}`
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id)
        const source = html.getElementById(id)

        if (source && destination) destination.innerHTML = source.innerHTML

        const price = document.getElementById(`Price-${this.dataset.section}`)

        if (price) price.classList.remove('visibility-hidden')
        this.toggleAddButton(!this.currentVariant.available)
      })
  }

  toggleAddButton(disable = true, loading = false) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`)
    if (!productForm) return
    const addButton = productForm.querySelector('[name="add"]')
    const addButtonText = productForm.querySelector('[name="add"] > span')
    const templateSuffix = addButton.getAttribute('data-template-suffix')
    const signedIn = addButton.getAttribute('data-signed-in') === 'true'? true : false

    if (!addButton) return

    if (disable && loading) {
      addButton.setAttribute('disabled', 'disabled')
      addButtonText.textContent = 'Loading'
    } else if (disable) {
      addButton.setAttribute('disabled', 'disabled')
      addButtonText.textContent = 'Sold Out'
    } else if (templateSuffix === 'must-login' && !signedIn) {
      addButton.removeAttribute('disabled')
      addButtonText.textContent = 'Login'
    } else if (templateSuffix === 'must-login' && signedIn) {
      addButton.setAttribute('disabled', 'disabled')
      addButtonText.textContent = 'Add to Cart'
    } else {
      addButton.removeAttribute('disabled')
      addButtonText.textContent = 'Add to Cart'
    }
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`)
    const addButton = button.querySelector('[name="add"]')
    const addButtonText = button.querySelector('[name="add"] > span')
    const price = document.getElementById(`Price-${this.dataset.section}`)
    if (!addButton) return
    addButtonText.textContent = 'Unavailable'
    if (price) price.classList.add('visibility-hidden')
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent)
    return this.variantData
  }
})

window.customElements.define('file-uploader', class FileUploader extends HTMLElement {
  constructor() {
    super()

    this.input = this.querySelector('input[type="file"]')
    this.visualInput = this.querySelector('.product-form__input')
    this.instructions = this.querySelector('.product-form__instructions')

    this.visualInput.addEventListener('click', this.handleClick.bind(this))
    if (this.instructions) this.input.addEventListener('change', this.updateInstructions.bind(this))
  }

  handleClick(evt) {
    this.input.click()
  }

  updateInstructions(evt) {
    if (this.input.checkValidity()) {
      this.instructions.textContent = evt.target.value.replace('C:\\fakepath\\', '')
    } else {
      this.instructions.textContent = 'No file chosen'
    }
  }
})

window.customElements.define('select-caret', class SelectCaret extends HTMLElement {
  constructor() {
    super()

    this.select = document.querySelector(`#${this.dataset.select}`)

    if (this.select) {
      this.select.addEventListener('click', this.onOpen.bind(this))
      this.select.addEventListener('mousedown', this.onOpen.bind(this))
      this.select.addEventListener('blur', this.onClose.bind(this))
      this.select.addEventListener('pointerleave', this.onClose.bind(this))
    }
  }

  onOpen(evt) {
    this.classList.add('product-form__select-caret--open')
  }

  onClose(evt) {
    this.classList.remove('product-form__select-caret--open')
  }
})

window.customElements.define('gift-note', class GiftNote extends HTMLElement {
  constructor() {
    super()

    this.formId = this.dataset.form
    this.toggle = this.querySelector('input[name="gift-note-toggle"]')
    this.giftInputsWrapper = this.querySelector('.gift-note__panel')
    this.giftInputs = Array.from(this.querySelectorAll('.gift-note__panel input, .gift-note__panel textarea'))
    this.toggle.addEventListener('change', this.toggleInputs.bind(this))
  }

  toggleInputs(evt) {
    this.giftInputs.forEach((input) => {
      if (evt.target.checked) {
        input.setAttribute('form', this.formId)
        this.giftInputsWrapper.classList.add('gift-note__panel--show')
      } else {
        input.removeAttribute('form')
        this.giftInputsWrapper.classList.remove('gift-note__panel--show')
      }
    })
  }
})

window.customElements.define('product-carousel', class ProductCarousel extends HTMLElement {
  constructor() {
    super()

    const config = {
      slidesPerView: 1.5,
      spaceBetween: 20,
      breakpoints: {
        768: {
          slidesPerView: 2.5
        },
        1024: {
          slidesPerView: 3.5
        },
        1280: {
          slidesPerView: 4.5
        },
      },
      pagination: {
        el: '.swiper-pagination',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    }

    let swiper = new Swiper(this, config)

    if (Shopify.designMode) {
      document.addEventListener('shopify:section:load', evt => {
        swiper = new Swiper(this, config)
      })

      document.addEventListener('shopify:section:unload', evt => {
        swiper.destroy()
      })
    }
  }
})

window.customElements.define('recently-viewed-products', class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super()

    this.container = this.querySelector('section')
    this.swiperTemplate = this.querySelector('template.recently-viewed-products-swiper-template')
    this.slideTemplate =  this.querySelector('template.recently-viewed-products-slide-template')
    this.productHandles = this.getRecentlyViewed()
    this.products = new Array(this.productHandles.length)
    this.init()
  }

  getRecentlyViewed() {
    const products = Cookies.get('recently-viewed-products')
    return products ? JSON.parse(products) : []
  }

  async init() {
    await this.fetchProducts()

    this.render()
    this.addRecentlyViewed()
  }

  async fetchProducts() {
    if (!this.productHandles.length) return

    let fetchPromises = this.productHandles.map(this.fetchProduct.bind(this))
    return Promise.all(fetchPromises)
  }

  async fetchProduct(productHandle, index) {
    try {
      let res = await fetch(`/products/${productHandle}.js`)
      res = await res.json()

      this.products.splice(index, 1, res)
    } catch (err) {
      console.error(err)
    }
  }

  render() {
    const swiperContainer = this.swiperTemplate.content.cloneNode(true)
    const slidesContainer = swiperContainer.querySelector('.swiper-wrapper')
    const badgeTags = ['Sale', 'New Arrivals', 'Best Seller']

    // Build section heading
    let heading = document.createElement('template')
    const headingDiv = `
      <div class="recently-viewed-products__product-carousel-heading">
        <h2>Recently Viewed</h2>
      </div>
    `
    heading.innerHTML = headingDiv.trim()
    heading = heading.content

    // Build product carousel
    this.products.forEach((product) => {
      const slideContainer = this.slideTemplate.content.cloneNode(true)

      // Set Url
      const slideLink = slideContainer.querySelector('.card');
      slideLink.href = product.url

      // Set Badge
      const slideBadge = slideContainer.querySelector('.card__badge')
      const badgeTag = product.tags.find((tag) => badgeTags.includes(tag))
      if (badgeTag) {
        const badgeHandle = badgeTag.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')
        slideBadge.classList.add(`card__badge--${badgeHandle}`)
        slideBadge.textContent = badgeTag
      } else {
        slideBadge.remove()
      }

      // Set Image
      if (product.featured_image) {
        const imageUrl = new URL(product.featured_image, window.location.origin)
        const imageExtentionIndex = imageUrl.pathname.lastIndexOf('.')
        const image = document.createElement('img')
        imageUrl.pathname = `${imageUrl.pathname.slice(0, imageExtentionIndex)}_200x160${imageUrl.pathname.slice(imageExtentionIndex)}`
        image.src = imageUrl.toString()
        slideContainer.querySelector('.card__image').appendChild(image)
      }

      // Set Title
      slideContainer.querySelector('.card__title').textContent = product.title

      // Set Price
      const price = slideContainer.querySelector('.card__price')
      price.lastChild.textContent = Shopify.formatMoney(product.price)
      if (product.compare_at_price) {
        price.querySelector('.card__compare-price').textContent = Shopify.formatMoney(product.compare_at_price)
      } else {
        price.querySelector('.card__compare-price-wrap').remove()
      }

      // Set Button
      slideContainer.querySelector('.card__button button').dataset.product = product.handle

      slidesContainer.appendChild(slideContainer)
    })

    // Render sections
    this.container.innerHTML = ''
    this.container.append(heading, swiperContainer)

    // Init quick views

  }

  addRecentlyViewed() {
    // Abort if we're not on a product page
    if (!window.location.pathname.includes('/products/')) return

    let handles = this.productHandles
    const currentHandle = window.location.pathname.substring(window.location.pathname.lastIndexOf('/products/') + 10)
    const productHasBeenRecentlyViewed = handles.some((handle) => handle === currentHandle)

    // If the product is already on the list, remove it so we don't have duplicates
    if (productHasBeenRecentlyViewed) handles = handles.filter((handle) => handle !== currentHandle)

    handles.unshift(currentHandle)

    if (handles.length > 5) handles.pop()

    this.productHandles = handles
    Cookies.set('recently-viewed-products', JSON.stringify(this.productHandles))
  }
})


// Show a simple interstitial modal with a spinner
// --------------------------------
export function showLogoutInterstitial() {
  // Create modal
  const modal = document.createElement("div");
  modal.id = "blue-interstitial";
  modal.innerHTML = `
        <div class="blue-box">
          <div class="spinner"></div>
          <div class="text">Loading...</div>
        </div>
      `;

  // Inject styles
  const style = document.createElement("style");
  style.textContent = `
        #blue-interstitial {
          position: fixed;
          inset: 0;
          background: rgba(0, 60, 150, 0.95);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 99999;
          transition: opacity .3s ease;
        }
        #blue-interstitial.fade {
          opacity: 0;
          pointer-events: none;
        }
        .blue-box {
          text-align: center;
          color: #fff;
          font-family: system-ui, sans-serif;
        }
        .spinner {
          width: 40px;
          height: 40px;
          margin: 0 auto 15px;
          border: 4px solid rgba(255,255,255,.3);
          border-top-color: #fff;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `;
  document.head.appendChild(style);
  document.body.appendChild(modal);

  // Show modal
  modal.style.display = "flex";
}

// Hide the interstitial modal
// --------------------------------
export function hideLogoutInterstitial() {
  // Kill modal with fade out
  const modal = document.querySelector("#blue-interstitial");
  modal.classList.add("fade");
  setTimeout(() => modal.remove(), 300);
}

// Global delegation for login/logout data-action triggers (replaces Alpine @click bindings)
// --------------------------------
document.addEventListener('click', (e) => {
  const action = e.target.closest('[data-action]')?.dataset.action
  if (action === 'akc-login') window.akc?.getLoginScreenset()
  if (action === 'akc-logout') window.akc?.getLogoutScreenset()
})

// Header account dropdown — stays open 4s after mouse leaves, closes on outside click
// --------------------------------
document.addEventListener('DOMContentLoaded', () => {
  // Desktop account dropdown
  const accountMenu = document.querySelector('.header__account-menu')
  if (!accountMenu || !accountMenu.querySelector('.header__account-dropdown')) return

  let hideTimer = null

  const cancelHide = () => clearTimeout(hideTimer)
  const scheduleHide = () => {
    cancelHide()
    hideTimer = setTimeout(() => accountMenu.classList.remove('is-open'), 4000)
  }

  accountMenu.addEventListener('mouseenter', () => {
    cancelHide()
    accountMenu.classList.add('is-open')
  })
  accountMenu.addEventListener('mouseleave', scheduleHide)
  document.addEventListener('click', (e) => {
    if (!accountMenu.contains(e.target)) {
      cancelHide()
      accountMenu.classList.remove('is-open')
    }
  })
})
